import React from 'react';
import { QuestionnaireQuestion } from '../../services/sowConversationService';
import { MultipleChoiceQuestion } from './MultipleChoiceQuestion';

// Temporary stub - falls back to MultipleChoiceQuestion for now
interface CombinedQuestionProps {
  question: QuestionnaireQuestion;
  onContinue: (response: string) => Promise<void>;
  onImageUpload?: (file: File) => Promise<string>;
  onImageUploaded?: () => void;
  onImageAssessment?: (imageId: string, questionId: string, attemptNumber: number) => Promise<any>;
  isSubmitting: boolean;
}

export const CombinedQuestion: React.FC<CombinedQuestionProps> = (props) => {
  // For now, just use MultipleChoiceQuestion
  return <MultipleChoiceQuestion {...props} />;
};